import { ASSET_TYPE, LIABILITY_TYPE, REPORT_ITEM_TYPE } from '../type/AssetReport.type';

export const getDefaultUploadCategory1 = (value: string) => {
  return value === '자산' ? REPORT_ITEM_TYPE.ASSET : REPORT_ITEM_TYPE.LIABILITY;
};

export const getDefaultUploadCategory2 = (value: string) => {
  switch (value) {
    case '자유입출금 자산':
    case '현금 자산':
    case '전자금융 자산':
      return ASSET_TYPE.EXPECT_TO_CONSUME;
    case '신탁 자산':
    case '부동산':
    case '동산':
    case '기타 실물 자산':
    case '보험 자산':
      return ASSET_TYPE.ETC;
    case '저축성 자산':
      return ASSET_TYPE.SAVINGS;
    case '투자성 자산':
      return ASSET_TYPE.INVESTMENT;
    case '장기대출':
    case '단기대출':
      return LIABILITY_TYPE.LOAN;
  }
  return ASSET_TYPE.ETC;
};
